<template>
    <ul class="invalid-feedback list-unstyled" :style="display">
        <li v-for="(message, index) in errors">{{message | trans}}</li>
    </ul>
</template>
<script>
    export default {
        props: ['fieldName'],
        computed: {
            errors() {
                return  this.$store.getters['formErrors/getErrors'](this.fieldName);
            },
            display() {
                let display = 'none';
                if(this.$store.getters['formErrors/getErrors'](this.fieldName).length) {
                    display = 'block';
                }
                return {display: display};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form-errors.vue